export function getBase64ImageDimensions(
  file
): Promise<{width: number; height: number}> {
  return new Promise(function (resolved) {
    const i = new Image()
    i.onload = function () {
      resolved({width: i.width, height: i.height})
    }
    i.src = file
  })
}
